import React from 'react';
import { DatePicker, Space, Tabs } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';

import { CalendarsSearchInput, CalendarsTable } from 'widgets/CalendarsTable';

import { calendarStore } from 'entities/calendar';

import { ReactComponent as ArrowBottom } from 'shared/assets/icons/dynamicColor/arrow-bottom.svg';
import tabStyles from 'shared/styles/ant-custom-components/tabs.module.scss';

import styles from './CalendarsPage.module.scss';

const CalendarsPage: React.FC = () => {
  const { t } = useTranslation('Calendar');
  const { selectedYear, selectYear } = useStore(calendarStore);

  return (
    <article className={styles.wrapper}>
      <Tabs
        className={tabStyles.customTabs}
        tabBarExtraContent={{
          right: (
            <Space>
              <CalendarsSearchInput />
              <DatePicker
                value={dayjs({ year: selectedYear })}
                onChange={(value) => selectYear(value.year())}
                picker="year"
                suffixIcon={<ArrowBottom height="8px" width="12px" />}
                allowClear={false}
                className={styles.datePicker}
              />
            </Space>
          ),
        }}
        items={[
          {
            label: t('page.tabs.calendar.title'),
            key: 'calendars',
            children: <CalendarsTable />,
          },
        ]}
      />
    </article>
  );
};

export default CalendarsPage;
